import React, { useMemo } from 'react'
import SpellcheckIcon from '@mui/icons-material/Spellcheck'
import CompressIcon from '@mui/icons-material/Compress'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TranslateIcon from '@mui/icons-material/Translate'
import TuneIcon from '@mui/icons-material/Tune'
import lang from 'lang'
import CascadingContextMenu from '@/modules/base/components/cascading-context-menu/cascading-context-menu'

interface AiTextTransformContextMenuProps {
  anchorEl: HTMLElement | null
  open: boolean
  onClose: () => void
  onSelectOption: (optionId: string) => void
}

export const AiTextTransformContextMenu: React.FC<AiTextTransformContextMenuProps> = ({
  anchorEl,
  open,
  onClose,
  onSelectOption,
}) => {

  const position = useMemo(() => {
    if (!anchorEl || !open) return null

    const rect = anchorEl.getBoundingClientRect()
    return {
      top: rect.bottom + window.scrollY,
      left: rect.left + window.scrollX,
    }
  }, [anchorEl, open])

  const menuItems = useMemo(() => [
    {
      key: 'spellcheck',
      label: lang.ai.textTransform.contextMenu.options.spellcheck,
      icon: SpellcheckIcon,
      onClick: () => onSelectOption('spellcheck'),
    },
    {
      key: 'shorten',
      label: lang.ai.textTransform.contextMenu.options.shorten,
      icon: CompressIcon,
      onClick: () => onSelectOption('shorten'),
    },
    {
      key: 'lengthen',
      label: lang.ai.textTransform.contextMenu.options.lengthen,
      icon: ExpandMoreIcon,
      onClick: () => onSelectOption('lengthen'),
    },
    {
      key: 'tone',
      label: lang.ai.textTransform.contextMenu.options.tone,
      icon: TuneIcon,
      children: [
        {
          key: 'tone-professional',
          label: lang.ai.textTransform.contextMenu.options.toneProfessional,
          onClick: () => onSelectOption('tone-professional'),
        },
        {
          key: 'tone-simple',
          label: lang.ai.textTransform.contextMenu.options.toneSimple,
          onClick: () => onSelectOption('tone-simple'),
        },
      ],
    },
    {
      key: 'translate',
      label: lang.ai.textTransform.contextMenu.options.translate,
      icon: TranslateIcon,
      children: [
        {
          key: 'translate-en',
          label: lang.ai.textTransform.contextMenu.options.translateEn,
          onClick: () => onSelectOption('translate-en'),
        },
        {
          key: 'translate-de',
          label: lang.ai.textTransform.contextMenu.options.translateDe,
          onClick: () => onSelectOption('translate-de'),
        },
      ],
    },
  ], [onSelectOption])

  return (
    <CascadingContextMenu
      menuItems={menuItems}
      position={position}
      onClose={onClose}
      closeOnClick={true}
      vertical="top"
      horizontal="left"
    >
      <div />
    </CascadingContextMenu>
  )
}
